import { Dispatch } from 'react-redux';

import { Action } from '../../actions';
import { StoreState } from '../../reducers';
import { Api } from '../../typings/api';
import ApiUtils from '../../utils/api';
import { createNotification } from '../NotificationBar/actions';

export enum ShareWithUserPopupActionKeys {
	GET_USERS = '@@shareWithUser/GET_USERS',
	SET_USERS = '@@shareWithUser/SET_USERS',
	SELECT_USER = '@@shareWithUser/SELECT_USER',
	RESET = '@@shareWithUser/RESET',
}

interface GetUsersAction extends Action {
	type: ShareWithUserPopupActionKeys.GET_USERS;
	resourceGId: number;
}

interface SetUsersAction extends Action {
	type: ShareWithUserPopupActionKeys.SET_USERS;
	users: Api.ShareUser[];
}

interface SelectUserAction extends Action {
	type: ShareWithUserPopupActionKeys.SELECT_USER;
	userId: number;
}

interface ResetAction extends Action {
	type: ShareWithUserPopupActionKeys.RESET;
}

export type ShareWithUserPopupAction =
	GetUsersAction |
	SetUsersAction |
	SelectUserAction |
	ResetAction;

const setUsers = (users: Api.ShareUser[]): SetUsersAction => ({
	type: ShareWithUserPopupActionKeys.SET_USERS,
	users,
});

export const selectUser = (userId: number): SelectUserAction => ({
	type: ShareWithUserPopupActionKeys.SELECT_USER,
	userId,
});

export const reset = (): ResetAction => ({
	type: ShareWithUserPopupActionKeys.RESET,
});

export const getShareUsers = (resourceGId: number) => async (dispatch: Dispatch<StoreState>, getState: () => StoreState): Promise<void> => {
	try {
		const action: GetUsersAction = {
			type: ShareWithUserPopupActionKeys.GET_USERS,
			resourceGId,
		};
		dispatch(action);

		const users = await ApiUtils.getShareUsers();
		const { profile: { id: currentUserId } } = getState();
		const filteredUsers = users.filter(({ id }) => id !== currentUserId);
		dispatch(setUsers(filteredUsers));
	} catch (error) {
		dispatch(reset());
		dispatch(createNotification('error.get_share_users'));
	}
};

export const shareWithUser = () => async (dispatch: Dispatch<StoreState>, getState: () => StoreState): Promise<void> => {
	try {
		const { shareWithUserPopup: { resourceGId, selectedUserId } } = getState();
		await ApiUtils.shareWithUser(resourceGId as number, selectedUserId as number);
		dispatch(createNotification('info.share_with_user_success'));
	} catch (error) {
		dispatch(createNotification('error.share_with_user'));
	} finally {
		dispatch(reset());
	}
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/ShareWithUserPopup/actions.ts